import { render, staticRenderFns } from "./PaymentLogo.vue?vue&type=template&id=0a234d1e&scoped=true&"
import script from "./PaymentLogo.vue?vue&type=script&lang=ts&"
export * from "./PaymentLogo.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentLogo.vue?vue&type=style&index=0&id=0a234d1e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a234d1e",
  null
  
)

export default component.exports